var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccessDevices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.5H2C1.45333 1.5 1 1.94667 1 2.5V10.5C1 11.0533 1.45333 11.5 2 11.5H6V13.5H4V14.5H12V13.5H10V11.5H14C14.5533 11.5 15 11.0533 15 10.5V2.5C15 1.94667 14.5533 1.5 14 1.5ZM9 13.5H7V11.5H9V13.5ZM14 10.5H2V2.5H14V10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccessDevices);
export default __webpack_public_path__ + "static/media/ic-access-devices.509757a46a7dbb6dc5afd327dfa0d4ca.svg";
export { ForwardRef as ReactComponent };